<template>
  <div class="d-flex align-center justify-space-between">
    <div
      class="d-flex align-center flex-grow-1"
      :style="{
        cursor: currentPage == 1 ? 'not-allowed' : 'pointer',
        opacity: currentPage == 1 ? 0.27 : 1,
        flexBasis: 0
      }"
      @click="decrementPage"
    >
      <!-- <v-icon size="28">mdi-chevron-left</v-icon> -->
      <Arrow
        borderWidth="1px"
        width="4px"
        class="left"
        :style="{ marginRight: '4px' }"
      />
      <div class="text-p3">{{$t('PreviousMsg')}}</div>
    </div>

    <div class="text-p5" v-if="totalPages !== 0 && totalPages !== 1">
      {{ currentPage }} of {{ totalPages }}
    </div>

    <div
      class="d-flex align-center flex-grow-1 justify-end"
      :style="{
        cursor:
          currentPage == totalPages || totalPages === 0
            ? 'not-allowed'
            : 'pointer',
        opacity: currentPage == totalPages || totalPages === 0 ? 0.27 : 1,
        flexBasis: 0
      }"
      @click="incrementPage"
    >
      <div class="text-p3">{{$t('NextMsg')}}</div>
      <Arrow
        borderWidth="1px"
        width="4px"
        class="right"
        :style="{ marginLeft: '4px' }"
      />
      <!-- <v-icon size="20">mdi-chevron-right</v-icon> -->
    </div>
  </div>
  <!--
  <v-row class="mt-0" justify-md="end">
    <v-col cols="12" md="6" class="d-flex justify-end">
      <v-pagination
        v-model="currentPageModel"
        v-bind="$attrs"
      />
    </v-col>
  </v-row>
  -->
</template>

<script>
import Arrow from '../Utils/Arrow.vue'

export default {
  components: {
    Arrow
  },
  props: {
    currentPage: {
      required: true,
      default: null
    },
    totalPages: {
      default: null
    }
  },

  computed: {
    currentPageModel: {
      get() {
        return this.currentPage
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    incrementPage() {
      if (this.currentPage !== this.totalPages && this.totalPages !== 0) {
        this.currentPageModel += 1
      }
    },

    decrementPage() {
      if (this.currentPage !== 1) {
        this.currentPageModel -= 1
      }
    }
  }
}
</script>

<style scoped>
</style>
